import React from 'react';
import { TradeBadge } from '../UI/TradeBadge';

/**
 * Stacked from→to change lines for employment movements.
 * Matches Employment History table readability on Timeline view.
 *
 * @param {object} props
 * @param {{ label: string, from?: string|null, to?: string|null }[]} props.diffs
 * @param {boolean} [props.showTradeBadges=true]
 */
export default function MovementDiffLines({ diffs = [], showTradeBadges = true }) {
  if (!diffs.length) return null;

  return (
    <div className="space-y-1">
      {diffs.map((diff, index) => (
        <div
          key={`${diff.label}-${index}`}
          className={
            showTradeBadges && diff.label === 'Trade'
              ? 'flex items-center gap-1.5 flex-wrap text-xs leading-snug'
              : 'text-xs leading-snug'
          }
        >
          <span className="text-gray-500 font-medium">{diff.label}:</span>{' '}
          {showTradeBadges && diff.label === 'Trade' ? (
            <>
              {diff.from ? <TradeBadge name={diff.from} size="xs" /> : <span className="text-gray-400">—</span>}
              <span className="text-gray-400" aria-hidden="true">→</span>
              {diff.to ? <TradeBadge name={diff.to} size="xs" /> : <span className="text-gray-400">—</span>}
            </>
          ) : (
            <>
              <span className="text-gray-400 line-through">{diff.from || '—'}</span>
              <span className="text-gray-400 mx-0.5" aria-hidden="true">→</span>
              <span className="font-medium text-gray-900">{diff.to || '—'}</span>
            </>
          )}
        </div>
      ))}
    </div>
  );
}
